import { render, staticRenderFns } from "./Sku.vue?vue&type=template&id=bb1b01b4&scoped=true"
import script from "./Sku.vue?vue&type=script&lang=js"
export * from "./Sku.vue?vue&type=script&lang=js"
import style0 from "./Sku.vue?vue&type=style&index=0&id=bb1b01b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1b01b4",
  null
  
)

export default component.exports